export default __webpack_public_path__ + "images/766c8e62a81a1f7cb2bb710470df4dc2-seattle_desktop.webp";